import {
  IUploadPODEntry,
  IUploadPODStore
} from '../pages/load-management/all-loads/upload-and-update/upload-and-update.interface';

export const initialPodEntries: IUploadPODEntry[] = [
  {
    shipmentNo: 'S456789',
    name: '',
    dateTime: null,
    document: null,
    signature: ''
  },
  {
    shipmentNo: 'S123546',
    name: '',
    dateTime: null,
    document: null,
    signature: ''
  }
];
export const initialUploadPODState: IUploadPODStore = {
  pods: initialPodEntries,
  showPODPopup: false,
  isUploading: false,
  errors: {}
};
